import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const PencilSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.95215 9.25317L8.6642 3.53932L12.4596 7.33353L6.74755 13.0474L2.95215 9.25317Z" fill="CurrentColor" />
    <path
      d="M13.4026 6.39337L13.8826 5.91404C14.385 5.41028 14.6671 4.72784 14.6671 4.01637C14.6671 3.30491 14.385 2.62247 13.8826
      2.11871C13.3788 1.6163 12.6964 1.33417 11.9849 1.33417C11.2734 1.33417 10.591 1.6163 10.0872 2.11871L9.60791 2.59871L13.4026 6.39337Z"
      fill="CurrentColor"
    />
    <path
      d="M5.59978 13.7868L2.16245 14.6454C2.0508 14.6734 1.93381 14.6719 1.82288 14.6412C1.71195 14.6105 1.61086 14.5516
      1.52944 14.4703C1.44802 14.3889 1.38905 14.2879 1.35827 14.177C1.32749 14.0661 1.32594 13.9491 1.35378 13.8374L2.21312 10.4001L5.59978 13.7868Z"
      fill="CurrentColor"
    />
  </svg>
);

const Pencil = (props: IIconProps) => <Icon component={PencilSvg} {...props} />;

export default Pencil;
